let latestUserConsentResult;
let consentReady = false; // consent 是否已就绪（用户做出选择）
const eventQueue = []; // 异常上报队列
let eventLoopTimer;
/**
 * pixel sdk 是否已加载
 */
let pixelSDkLoaded = false;
const innerInit = (f, b, e, v, callback) => {
    if (f.fbq) {
        return;
    }
    const n = (f.fbq = function () {
        if (n.callMethod) {
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            n.callMethod.apply(n, arguments);
        }
        else if (n.queue) {
            // eslint-disable-next-line prefer-rest-params
            n.queue.push(arguments);
        }
    });
    if (!f._fbq) {
        f._fbq = n;
    }
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e);
    t.async = !0;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    t.onload = () => {
        callback();
    };
    t.onerror = () => {
        /**
         * 5s 后重试一次
         */
        setTimeout(() => {
            const t = b.createElement(e);
            t.async = !0;
            t.src = v;
            const s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
            t.onload = () => {
                callback();
            };
        }, 5000);
    };
};
/**
 * 初始化 meta pixel
 * @returns
 */
export function initMetaPixel(options) {
    if (!options.id) {
        return;
    }
    innerInit(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', () => {
        pixelSDkLoaded = true;
        if (options.needConsent) {
            setTimeout(() => {
                grantConsentMetaPixel();
            }, 0);
        }
    });
    if (options.needConsent) {
        window.fbq('consent', 'revoke');
    }
    window.fbq('init', options.id);
    window.fbq('track', 'PageView');
}
/**
 * 确认数据相关的协议
 * @param result
 */
export function confirmMetaPixelConsent(result) {
    latestUserConsentResult = result;
    consentReady = true;
    grantConsentMetaPixel();
}
function grantConsentMetaPixel() {
    if (latestUserConsentResult && pixelSDkLoaded) {
        if (latestUserConsentResult.ad && latestUserConsentResult.analytics) {
            window.fbq('consent', 'grant');
        }
    }
}
function innerTrackFBQ(action, event, params = {}, extraParams = {}) {
    window.fbq(action, event, params, extraParams);
}
function trackEventFromQueue() {
    if (consentReady && window.fbq) {
        if (eventLoopTimer) {
            clearInterval(eventLoopTimer);
            eventLoopTimer = 0;
        }
        while (eventQueue.length) {
            const item = eventQueue.shift();
            if (item) {
                innerTrackFBQ(item.action, item.event, item.params, item.extraParams);
            }
        }
    }
}
/**
 * 调用 pixel api
 */
function fbq(action, event, params = {}, extraParams = {}) {
    if (consentReady && window.fbq) {
        innerTrackFBQ(action, event, params, extraParams);
    }
    else {
        eventQueue.push({
            event,
            params,
            action,
            extraParams
        });
        if (!eventLoopTimer) {
            eventLoopTimer = setInterval(() => {
                trackEventFromQueue();
            }, 1000);
        }
    }
}
/**
 * 触发标准事件
 * @link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking
 * @param event
 * @param params
 * @param extraParams
 */
export function trackFbq(event, params = {}, extraParams = {}) {
    fbq('track', event, params, extraParams);
}
/**
 * 触发自定义事件
 * @link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking
 * @param event
 * @param params
 * @param extraParams
 */
export function trackCustomFbq(event, params = {}, extraParams = {}) {
    fbq('trackCustom', event, params, extraParams);
}
